'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ClientsGroupCtrl
 * @description
 * # ClientCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ClientsGroupCtrl', ['$scope', 'ClientsGroup', 'Pagination', '$rootScope', function ($scope, ClientsGroup, Pagination, $rootScope) {

    const SEARCH_ATTRIBUTES = {
      'search': '',
      'by_column': '',
      'filters': {
        'id': 'fa-sort-asc',
        'name': 'fa-sort',
      }
    };
    $scope.search = SEARCH_ATTRIBUTES;

    $scope.client_groups = {
      list: [],
      pager: {}
    };

    $scope.getPage = function(page) {
      var params = {
        params: {
          page: page,
          per_page: 10,
          search: $scope.search.search,
          by_column: $scope.search.by_column
        }
      };
      ClientsGroup.index(params).then(function(response) {
        $scope.client_groups.list = response.data.client_groups;
        $scope.client_groups.pager = Pagination.GetPager(
          response.data.meta.pagination.total_objects,
          page,
          response.data.meta.pagination.per_page);
      },function(error) {
        ClientsGroup.error(error);
      });
    };

    $scope.clearSearch = function() {
      $scope.search = SEARCH_ATTRIBUTES;
      $scope.search.search = '';
      $scope.getPage(1);
    }

    $scope.pager = {};
    $scope.getPage(1);

    $scope.filter = function(column) {
      var order = '';
      angular.forEach($scope.search.filters, function(value, key) {
        if(column === key) {
          if($scope.search.filters[key] === 'fa-sort-desc') {
            $scope.search.filters[key] = 'fa-sort-asc';
            order = 'ASC';
          } else {
            $scope.search.filters[key] = 'fa-sort-desc';
            order = 'DESC';
          }
        } else {
          $scope.search.filters[key] = 'fa-sort';
        }
      });
      $scope.search.by_column = {
        column: column,
        order: order
      };
      $scope.getPage(1);
    };

    $scope.deleteClientsGroup = function(client_group) {
      var index = $scope.client_groups.list.indexOf(client_group);
      ClientsGroup.delete(client_group.id).then(function() {
        $scope.client_groups.list.splice(index, 1);
      }, function(error) {
        ClientsGroup.error(error);
      });
    };


  }]);
